import { render, staticRenderFns } from "./SenderStatusChip.vue?vue&type=template&id=0eb32fa9&scoped=true"
import script from "./SenderStatusChip.vue?vue&type=script&lang=js"
export * from "./SenderStatusChip.vue?vue&type=script&lang=js"
import style0 from "./SenderStatusChip.vue?vue&type=style&index=0&id=0eb32fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb32fa9",
  null
  
)

export default component.exports